import React from 'react';
import styled from "styled-components";
import {Tr} from "../../../../layouts/tableLayout/_tr";
import {Th} from "../../../../layouts/tableLayout/_th";
import { Text } from 'common/text';

const Thead = ({isPrincipal, ...props}) => {
   return (
      <StyledThead>
         <Tr {...props} type="tHead">
            <Th className="principal-table__cell">STT</Th>
            <Th className="principal-table__cell">Danh mục</Th>
            <Th className="principal-table__cell">Danh mục cha</Th>
            {isPrincipal && <Th className="principal-table__cell">HH ĐLC1</Th>}
            <Th className="principal-table__cell">
              <Text fontWeight={600}>
                HH ĐLC2{isPrincipal && " Manager cho phép" }
              </Text>
            </Th>
            <Th className="principal-table__cell">Số lượng sản phẩm</Th>
         </Tr>
      </StyledThead>
   )
}

export default Thead


export const StyledThead = styled.div`
  .principal-table {
    &__cell {
      margin: 0 8px;
      display: flex;
      align-items: center;
    }
     &__cell:nth-child(1) {
      width: 50px;
      justify-content: center;
    }
    &__cell:nth-child(2) {
    flex: 1;
    }
    &__cell:nth-child(3) {
      width:20%;
    }
    &__cell:nth-child(4) {
      width: 10%;
      text-align: center;
      justify-content: center;
    }
    &__cell:nth-child(5) {
      width:10%;
      text-align: center;
      justify-content: center;
    }
    &__cell:nth-child(6) {
      width: 10%;
      text-align: center;
      justify-content: center;
    }
  }
`
